// packages
import Markdown from "markdown-to-jsx";
import { useEffect, useState } from "react";

const Policy = () => {
  const file_name = "KOLYDE_Cookie_Policy_1-5-22.md";
  const [post, setPost] = useState("");

  useEffect(() => {
    import(`../../../markdown/${file_name}`)
      .then((res) => {
        fetch(res.default)
          .then((res) => res.text())
          .then((res) => setPost(res));
      })
      .catch((err) => console.log(err));
  });

  return (
    <div class="doc-container px-6 mx-auto flex items-center flex-col py-20">
      <h2 class=" text-2xl font-medium mb-5">Cookies Policy</h2>
      <Markdown>{post}</Markdown>
    </div>
  );
};

export default Policy;
